define(
    'models/user.model',[
        'loader',
        'config',
        'helper',
        'sandbox'
    ],
    function (
        Loader,
        Config,
        Helper,
        Sandbox
        )
    {
        var _ = Loader._;

        var UserModel = Loader.Backbone.Model.extend({

            defaults: {
                id:         null,
                login:      '',
                groupId:    3,
                avatar:     '',
                name:       '',
                title:      '',
                sex:        0,
                age:        0,
                birthDate:  '',
                registered: null,
                inviteCode: null,
                posts:      0,
                lastPost:   null,
                lastVisit:  null,
                totalTime:  null,
                respectPlus: 0,
                respectMinus: 0,
                positivePlus: 0,
                positiveMinus: 0,
                birthDateB64: -1,
                mail: '',
                mailMD5: ''
            },

            initialize: function()
            {
                var _this = this;
                this.model = this.get('model');
            },

            isAdmin: function()
            {
                return this.get('groupId') == 1;
            },

            isMainAdmin: function()
            {
                return this.get('id') == 2;
            },

            isModerator: function()
            {
                return this.get('groupId') == 2;
            },

            isGuest: function()
            {
                return this.get('groupId') == 3;
            }

        });

        return UserModel;
    }
);

